import { jsPDF } from "jspdf"

const FetchAsBase64 = async url => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((onSuccess, onError) => {
    try {
      const reader = new FileReader() ;
      reader.onload = function(){ onSuccess(this.result.split('base64,')[1]) } ;
      reader.readAsDataURL(blob) ;
    } catch(e) {
      onError(e);
    }
  });
};

export const interRegular = async () => {
  const font = await FetchAsBase64('https://rsms.me/inter/font-files/InterVariable.ttf');
  var callAddFont = function () {
    this.addFileToVFS('InterVariable.ttf', font);
    this.addFont('InterVariable.ttf', 'Inter', 'normal');
    this.addFont('InterVariable.ttf', 'Inter', 'bold');
  };
  jsPDF.API.events.push(['addFonts', callAddFont])
}

export default interRegular